import { render, staticRenderFns } from "./IconConnector.vue?vue&type=template&id=0bccaead&scoped=true"
import script from "./IconConnector.vue?vue&type=script&lang=js"
export * from "./IconConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccaead",
  null
  
)

export default component.exports